"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelsWithAccess = void 0;
const getModelsWithAddedAccess_1 = require("./getModelsWithAddedAccess");
const getModelsWithAccess = (state) => {
    if (state) {
        return (0, getModelsWithAddedAccess_1.getModelsWithAddedAccess)()(state.models);
    }
    return [];
};
exports.getModelsWithAccess = getModelsWithAccess;
